// extracted by mini-css-extract-plugin
module.exports = {"title":"_1QeZErUaIlOeay2ZVssima","date":"_1L4jg2JNdMlyiA8NUQi4wD","annotationIcon":"DeU3dXnq9cQbpsmRWysyY","subHeader":"_38MOWm26xQQruIHtFm8Du6"};